export default __webpack_public_path__ + "static/media/phoenix.5e732bf3.svg";